export const handleUserSelection = (
  currentValues: string[],
  newValues: string[],
  setFunc: (values: string[]) => void,
  exclusiveValues: string[] = ['all'],
): void => {
  if (newValues.length === 0) {
    setFunc([exclusiveValues[0]]);
    return;
  }

  const added = newValues.filter(v => !currentValues.includes(v));
  const addedExclusive = added.find(v => exclusiveValues.includes(v));

  if (addedExclusive) {
    setFunc([addedExclusive]);
    return;
  }

  setFunc(newValues.filter(v => !exclusiveValues.includes(v)));
};
